import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import CustomizedSnackbars from "../../components/snackbar/Snackbar";
import { NavMode } from "../../helpers/enums/Layout";
import { useAppDispatch, useAppSelector } from "../../store/hooks/hook";
import { changeNavType } from "../../store/slices/Layout/LayoutSlice";
import AppFooter from "./footer/AppFooter";
import ContentHeader from "./ContentHeader";
import AppHeader from "./header/AppHeader";
import CookieConsent, { Cookies } from "react-cookie-consent";
import { loadGoogleTagManager } from "../../services/analytics/_GoogleAnalytics";
import { loadGoogleTagManagerNoScript } from "../../services/analytics/_GoogleAnalyticsNoScript";
import GTMCookieConsentModal from "../../components/modal/GTMCookieConsent"

const COOKIE_NAME = "GTMCookieDisplayed";

const LeadsLayout = () => {
    const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;
    const { navMode } = useAppSelector((state) => ({
        navMode: state.reducer.Layout.navMode,
      }));
      
    const dispatch = useAppDispatch();
    const [showConsent, setShowConsent] = useState(false);

    useEffect(() => {
        dispatch(changeNavType(NavMode.LEADS));

        
        const consent = Cookies.get(COOKIE_NAME);
        if (consent === "true" && GTM_ID) {
            // Already displayed, load GTM immediately           
                loadGoogleTagManager(GTM_ID);
                loadGoogleTagManagerNoScript(GTM_ID);           
        } else if (consent === undefined) {
            // Not displayed yet, show modal
            setShowConsent(true);
        }
        

    }, []);
    

return (
    <React.Fragment>
      <div className="app-wrapper">
            {navMode === NavMode.LEADS && (
                <AppHeader navMode={navMode} />
            )}
            <div className="app-content">
                <Box className="progress-bar">
                    <CircularProgress />
                </Box>
                <ContentHeader hide={false} />
                <CustomizedSnackbars />
                <Outlet />
            </div>
            {showConsent && (
                <GTMCookieConsentModal/>
            )}
        </div>
    </React.Fragment>
  );
};

export default LeadsLayout;
